import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Camera } from '@classes/camera/camera';

export interface DialogData {
  camera: Camera;
}

@Component({
  selector: 'app-smartparking-camera-infos-last-sync',
  templateUrl: './smartparking-camera-infos-last-sync.component.html',
  styleUrls: ['./smartparking-camera-infos-last-sync.component.scss']
})
export class SmartparkingCameraInfosLastSyncComponent implements OnInit {
  today = new Date();
  constructor(
    public dialogRef: MatDialogRef<SmartparkingCameraInfosLastSyncComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
  }

}
